import Vue from "vue";
import { collect } from "collect.js";
import store from "./../store";
var VueCookie = require("vue-cookie");
const ACL_DEBUG = process.env.NODE_ENV == "development";
// Tell Vue to use the plugin
Vue.use(VueCookie);

const acl = {
  data() {
    return {
      // permissions: [],
      // roles: [],
      openRoutes: ["home", "404", "403", "dashboard", "report", "wr1",'force-change-password'],
      publicRoutes: ["downloads"],
      permissionsLoadded: false,
      rolesLoadded: false,
    };
  },

  created() {
    this.log("USER ROLES", this.roles);
  },
  watch: {
    permissions: function(_permissions) {
      if (_permissions.length > 0) this.permissionsLoadded = true;
    },
    roles: function(_roles) {
      this.log("ROLES CHANGED", _roles);
      if (_roles.length > 0) this.rolesLoadded = true;
    },
  },
  computed: {
    isReady() {
      return this.rolesLoadded;
    },
    permissions() {
      let data =
        store && store.state && store.state.permissions
          ? store.state.permissions
          : [];
      return data.length > 0
        ? data
        : JSON.parse(localStorage.getItem("permissions"));
    },
    roles() {
      let data =
        store && store.state && store.state.roles ? store.state.roles : [];
      return data.length > 0 ? data : JSON.parse(localStorage.getItem("roles"));
    },
    isSuperAdmin() {
      return this.roles && this.roles.find((e) => e == "super-admin") != null;
    },
    isDeveloper() {
      return this.roles && this.roles.find((e) => e == "Developer") != null;
    },
    isSupportUser() {
      return this.roles && this.roles.find((e) => e == "support_jetbar") != null;
    },
    isOwner() {
      return this.roles && this.roles.find((e) => e == "owner") != null;
    },
    isBroker() {
      if (this.isSuperAdmin) return true;
      if (
        this.isOwner &&
        store.state.user.model &&
        store.state.user.model.is_broker
      )
        return true;
    },
    isCarrier() {
      return this.roles && this.roles.find((e) => e == "carrier") != null;
    },
  },
  methods: {
    handleRoutes(to, from, next) {
      let user = store.state.user;

      if (!user || Object.keys(user).length === 0) {
        try {
          user = JSON.parse(localStorage.getItem("user")) || null;
        } catch (e) {
          user = null;
        }
      }

      const mustChangePassword = user?.force_password_change ?? false;

      if (!to.matched.length) {
        next("/404");
        return;
      }


  const isForceRoute = to.path === "/force-change-password";

      if (mustChangePassword && !isForceRoute) {
        next("/force-change-password");
        return;
      }

      if (!mustChangePassword && isForceRoute) {
        next("/");
        return;
      }
      if (to.name) {
        if (this.isPublicRoute(to.name)) return next();
        if (!this.hasToken() && to.path != "/login") {
          next("/login");
          return;
        } else {
          if (!this.can("view", to.name) && to.path != "/login") {
            next("/403");
            return;
          } else {
            next();
            return;
          }
        }
      }
    },
    can(operation, name) {
      let isOpenRoute = this.openRoutes.find((e) => e == name) ? true : false;
      let hasPermission =
        this.permissions &&
        this.permissions.find((e) => e == `${operation}_${name}`)
          ? true
          : false;
      let res = this.isSuperAdmin || isOpenRoute || hasPermission;
      return res;
    },

    isPublicRoute(routeName) {
      return this.publicRoutes.find((e) => e == routeName) ? true : false;
    },

    hasToken() {
      if (store.state.token || localStorage.getItem("token")) return true;
      return false;
    },

    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },

    setCookie(cname, cvalue, exsecond) {
      var d = new Date();
      d.setTime(d.getTime() + exsecond * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },

    log(_event, _payload) {
      // if (ACL_DEBUG)
      //   console.info(
      //     `%cDebug: ACL LOG`,
      //     "color: red; font-weight: 600",
      //     "Event:",
      //     _event,
      //     "Payload:",
      //     _payload
      //   );
    },
  },
};

export default acl;
